import React, { Component } from 'react';
import { Grid, Row, Col, Radio, Button, ButtonToolbar, Checkbox } from 'react-bootstrap';

const IDENTIFIER_TYPES = {
    NONE: 0,
    LINE_CODE: 1,
    LINE_NAME: 2,
    ORIGIN: 3,
    DESTINATION: 4,
    ORIGIN_DESTINATION: 5,
    HEADSIGN: 6
};

const EXTRA_IDENTIFIER_OPTIONS = [
    { value: IDENTIFIER_TYPES.NONE, label: "Nenhum" },
    { value: IDENTIFIER_TYPES.LINE_NAME, label: "Nome da Linha" },
    { value: IDENTIFIER_TYPES.ORIGIN, label: "Apenas Origem" },
    { value: IDENTIFIER_TYPES.DESTINATION, label: "Apenas Destino" },
    { value: IDENTIFIER_TYPES.ORIGIN_DESTINATION, label: "Origem - Destino" },
    { value: IDENTIFIER_TYPES.HEADSIGN, label: "Headsign" }
];

export class LineInformationDataIdentifier extends Component {
    constructor(props) {
        super(props);

        const defaultConfig = {
            showLineCode: true,
            extraIdentifierType: IDENTIFIER_TYPES.NONE,
            isUppercase: false
        };

        let parsedConfig = {};
        try {
            parsedConfig = props.configuration ? JSON.parse(props.configuration) : {};
        } catch (_) { }

        this.state = {
            form: {
                id: props.selectedData || null,
                showLineCode: undefined === parsedConfig.showLineCode ? defaultConfig.showLineCode : parsedConfig.showLineCode,
                extraIdentifierType: undefined === parsedConfig.extraIdentifierType ? defaultConfig.extraIdentifierType : parsedConfig.extraIdentifierType,
                isUppercase: undefined === parsedConfig.isUppercase ? defaultConfig.isUppercase : parsedConfig.isUppercase
            }
        };
    }

    componentDidMount() {
        this.updateParent(false);
    }

    getConfiguration() {
        const { showLineCode, extraIdentifierType, isUppercase } = this.state.form;

        return JSON.stringify({
            showLineCode,
            extraIdentifierType,
            isUppercase
        });
    };

    updateParent(close) {
        const { form } = this.state;

        this.props.onSelectData(form.id || null);
        this.props.onConfigureData(this.getConfiguration(), close);
    };

    updateFormField(field, value) {
        this.setState(
            prevState => ({
                form: {
                    ...prevState.form,
                    [field]: value
                }
            }),
            () => this.updateParent(false)
        );
    };

    saveAndClose() {
        this.updateParent(true);
    };

    toggleLineCode() {
        this.setState(
            prevState => {
                const { showLineCode, extraIdentifierType } = prevState.form;

                if (showLineCode && extraIdentifierType === IDENTIFIER_TYPES.NONE) {
                    return null;
                }

                return {
                    form: {
                        ...prevState.form,
                        showLineCode: !showLineCode
                    }
                };
            },
            () => this.updateParent(false)
        );
    }

    setExtraIdentifier(value) {
        this.setState(
            prevState => {
                const { showLineCode } = prevState.form;

                if (value === IDENTIFIER_TYPES.NONE && !showLineCode) {
                    return null;
                }

                return {
                    form: {
                        ...prevState.form,
                        extraIdentifierType: value
                    }
                };
            },
            () => this.updateParent(false)
        );
    }

    render() {
        const { form } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <b>Identificador da linha</b>
                            <div className="text-information">
                                Escolha a informação principal a apresentar na linha
                            </div>
                        </Col>
                    </Row>

                    <Row className="margin-top-12">
                        <Col sm={12}>
                            <Checkbox
                                checked={form.showLineCode}
                                onChange={() =>
                                    this.toggleLineCode()
                                }
                            >
                                Mostrar <b>Código da Linha</b>
                            </Checkbox>
                        </Col>
                    </Row>

                    <Row className="margin-top-10">
                        <Col sm={12}>
                            <div className="line-information-options">
                                <div className="text-information">
                                    Informação adicional (opcional)
                                </div>

                                {EXTRA_IDENTIFIER_OPTIONS.map(option => (
                                    <Radio
                                        key={option.value}
                                        name="extraIdentifierType"
                                        checked={form.extraIdentifierType === option.value}
                                        onChange={() =>
                                            this.setExtraIdentifier(option.value)
                                        }
                                    >
                                        {option.label}
                                    </Radio>
                                ))}
                            </div>
                        </Col>
                    </Row>


                    <Row className="margin-top-10">
                        <Col sm={12}>
                            <Checkbox
                                checked={form.isUppercase}
                                onChange={() =>
                                    this.updateFormField("isUppercase", !form.isUppercase)
                                }
                            >
                                Apresentar em <b>MAIÚSCULAS</b>
                            </Checkbox>
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.saveAndClose()}>
                        GUARDAR
                    </Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>
                        FECHAR
                    </Button>
                </ButtonToolbar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/LineInformationDataIdentifier.js